/**
 * RESPONSIBILITY: decide which framework screen the current URL maps to.
 *
 * This is the navigation table. `framework/react/location` answers "where am I",
 * `framework/react/screens/routes` declares "where can I go", and this file is the
 * one place that turns a hash into a rendered screen.
 *
 * Returns null when the URL is not a screen — meaning: render the site.
 */
import type { ReactNode } from 'react';
import {
  SCREENS, isScreen, goTo,
  LoginScreen, Profile, AdminScreen, FlushLocal, FlushServer, SecretFlags,
} from '@framework/react';

export function ScreenRouter({ hash }: { hash: string }): ReactNode | null {
  if (!isScreen(hash)) return null;

  const back = () => goTo(SCREENS.home);

  switch (hash) {
    case SCREENS.login:       return <LoginScreen onClose={back} />;
    case SCREENS.profile:     return <Profile onClose={back} />;
    case SCREENS.admin:       return <AdminScreen onClose={back} />;
    case SCREENS.flushLocal:  return <FlushLocal onClose={back} />;
    case SCREENS.flushServer: return <FlushServer onClose={back} />;
    case SCREENS.secretFlags: return <SecretFlags onClose={back} />;
    default:                  return null;
  }
}
